module.exports = __webpack_public_path__ + "img/Patipan.d6bbca00.jpg";